import { BaseMeasures } from './BaseMeasures.ts';

export const ExperienceActionMeasures = new BaseMeasures();
